import moment from 'moment';
import range from 'lodash/range';

module.exports = 'ttb.dashboard.burnDownStatusesDiagram.component';

angular.module(module.exports, [])
    .component('burnDownStatusesDiagram', {
        template:`<div class="card-box burn-down-statuses-diagram">
                       <h4 class="text-dark header-title m-t-0 m-b-30" translate>DashBoard_Statuses_Changes_Diagram</h4>
                       <div class="widget-chart text-center">
                           <div>
                               <canvas class="chart chart-line"
                                height='550'
                                chart-data="$ctrl.data" 
                                chart-labels="$ctrl.labels" 
                                chart-series="$ctrl.series" 
                                chart-options="$ctrl.options" 
                                chart-dataset-override="$ctrl.datasetOverride"></canvas>
                           </div>
                       </div>
                       <div ng-show="$ctrl.loading" class="panel-disabled"><div class ="loader-1"></div></div>
                   </div>`,
        controller: BurnDownStatusesDiagram,
        bindings: {
            team: '<'
        }
    });

function BurnDownStatusesDiagram(burnDownStatusesDiagramUrl, $http) {

    this.$onInit = function () {
        this.initData();
    };

    this.$onChanges = (changes) => {
        if (changes.team && !changes.team.isFirstChange()) {
            this.load(changes.team.currentValue);
        }
    }

    this.initData = () => {
        let now = moment();

        this.labels = range(-5, 5).map(day => now.add(day, 'd').format(ttb.constants.dateTime.SHORT_DATE_FORMAT));
        this.data = [[0]];
        this.options = {
            maintainAspectRatio: false,
            lineWidth: 0.5,
            titleFontSize : 9,
            scales: {
                yAxes: [
                    {
                        fontSize: 6,
                        gridLines: {
                            display: true,

                        },
                        ticks: {
                            beginAtZero: true,
                            suggestedMax: 50,
                            fontSize: 11
                        }
                    }
                ]
            }
        };
    }

    this.load = (team) => {
        this.loading = true;

        $http.get(burnDownStatusesDiagramUrl, { params: { teamId: team ? team.id : null, timestamp: new Date() } })
            .then(response => {
                    this.loading = false;

                    if (response.data) this.buildChart(response.data);
                    else this.initData();
                },
                () => {
                    this.loading = false;
                });
    }

    this.buildChart = (data) => {
        this.labels = data.map(x => x.Day);
        this.series = data[0].StatusItems.map(x => x.StatusName);

        let statusIds = data[0].StatusItems.map(x => x.StatusId);
        let chartData = [];

        for (var i in statusIds) {
            let id = statusIds[i];
            let line = data.map(x => x.StatusItems.filter(i => i.StatusId == id)[0]).map(x => x.TotalEffort);

            chartData.push(line);
        }

        this.data = chartData;

        this.datasetOverride =   data[0].StatusItems.map(x => ({

            type: 'line',
            backgroundColor: this.hex2rgb(this.nameToHex(x.StatusColor),'0.2'),
            pointBackgroundColor: '#fff',
            pointHoverBackgroundColor: this.nameToHex(x.StatusColor),
            borderColor: this.nameToHex(x.StatusColor),
            pointBorderColor: this.nameToHex(x.StatusColor),
            pointHoverBorderColor: this.hex2rgb(this.nameToHex(x.StatusColor),'0.8'),
            pointRadius: 3,
            pointBorderWidth: 1.5,
            borderWidth: 1.5
        }));

       
/*
        this.datasetOverride =
        [
           {
               type: 'line',
               backgroundColor: 'rgba(59,175,218,0.4)',
               pointBackgroundColor: '#fff',
               pointHoverBackgroundColor: 'rgba(59,175,218,1)',
               borderColor: 'rgba(59,175,218,1)',
               pointBorderColor: 'rgba(59,175,218,1)',
               pointHoverBorderColor: 'rgba(59,175,218,0.8)',
               pointRadius: 3,
               pointBorderWidth: 2
           },
           {
               type: 'line',
               backgroundColor: 'rgba(0,177,157,0.4)',
               pointBackgroundColor: '#fff',
               pointHoverBackgroundColor: 'rgba(0,177,157,1)',
               borderColor: 'rgba(0,177,157,1)',
               pointBorderColor: 'rgba(0,177,157,1)',
               pointHoverBorderColor: 'rgba(0,177,157,0.8)',
               pointRadius: 3,
               pointBorderWidth: 2
           }
       ];
         */ 

        this.options = {
            legend: { display: true, 
                labels: {
                    fontSize:11
                } 
            },
            tooltips: {
                titleFontSize: 11,
                bodyFontSize: 11
            },
            elements: {
                line: {
                    tension: 0,
                    lineWidth: 1
                }
            },
            animation: {
                duration: 200
            },
            responsiveAnimationDuration: 200,
            maintainAspectRatio: false,
            scales: {
                yAxes: [
                    {
                        gridLines: {
                            display: true,
                            lineWidth: 1
                        },
                        ticks: {
                            beginAtZero: true,
                            fontSize: 11,
                        }
                    }
                ],
                xAxes: [
                    {
                        gridLines: {
                            display: true,
                            lineWidth: 1
                        },
                        ticks: {
                            fontSize: 11,
                        }
                    }
                ]
            }
        };

    }
    
    this.nameToHex = function(name) {
        let colorCode = nameOfColors[name.toLowerCase()];

        return colorCode ? colorCode : name.toLowerCase();
      }
      

      this.hex2rgb = function hex2rgb(c, opactity) {
        if (c[0] === '#') c = c.substr(1);
        var r = parseInt(c.slice(0,2), 16),
            g = parseInt(c.slice(2,4), 16),
            b = parseInt(c.slice(4,6), 16);
        return 'rgb('+ r +','+ g +','+ b +','+opactity +')';
      }

      let nameOfColors = {
        "aliceblue": "#f0f8ff",
        "antiquewhite": "#faebd7",
        "aqua": "#00ffff",
        "aquamarine": "#7fffd4",
        "azure": "#f0ffff",
        "beige": "#f5f5dc",
        "bisque": "#ffe4c4",
        "black": "#000000",
        "blanchedalmond": "#ffebcd",
        "blue": "#0000ff",
        "blueviolet": "#8a2be2",
        "brown": "#a52a2a",
        "burlywood": "#deb887",
        "cadetblue": "#5f9ea0",
        "chartreuse": "#7fff00",
        "chocolate": "#d2691e",
        "coral": "#ff7f50",
        "cornflowerblue": "#6495ed",
        "cornsilk": "#fff8dc",
        "crimson": "#dc143c",
        "cyan": "#00ffff",
        "darkblue": "#00008b",
        "darkcyan": "#008b8b",
        "darkgoldenrod": "#b8860b",
        "darkgray": "#a9a9a9",
        "darkgreen": "#006400",
        "darkkhaki": "#bdb76b",
        "darkmagenta": "#8b008b",
        "darkolivegreen": "#556b2f",
        "darkorange": "#ff8c00",
        "darkorchid": "#9932cc",
        "darkred": "#8b0000",
        "darksalmon": "#e9967a",
        "darkseagreen": "#8fbc8f",
        "darkslateblue": "#483d8b",
        "darkslategray": "#2f4f4f",
        "darkturquoise": "#00ced1",
        "darkviolet": "#9400d3",
        "deeppink": "#ff1493",
        "deepskyblue": "#00bfff",
        "dimgray": "#696969",
        "dodgerblue": "#1e90ff",
        "firebrick": "#b22222",
        "floralwhite": "#fffaf0",
        "forestgreen": "#228b22",
        "fuchsia": "#ff00ff",
        "gainsboro": "#dcdcdc",
        "ghostwhite": "#f8f8ff",
        "gold": "#ffd700",
        "goldenrod": "#daa520",
        "gray": "#808080",
        "green": "#008000",
        "greenyellow": "#adff2f",
        "honeydew": "#f0fff0",
        "hotpink": "#ff69b4",
        "indianred ": "#cd5c5c",
        "indigo": "#4b0082",
        "ivory": "#fffff0",
        "khaki": "#f0e68c",
        "lavender": "#e6e6fa",
        "lavenderblush": "#fff0f5",
        "lawngreen": "#7cfc00",
        "lemonchiffon": "#fffacd",
        "lightblue": "#add8e6",
        "lightcoral": "#f08080",
        "lightcyan": "#e0ffff",
        "lightgoldenrodyellow": "#fafad2",
        "lightgrey": "#d3d3d3",
        "lightgreen": "#90ee90",
        "lightpink": "#ffb6c1",
        "lightsalmon": "#ffa07a",
        "lightseagreen": "#20b2aa",
        "lightskyblue": "#87cefa",
        "lightslategray": "#778899",
        "lightsteelblue": "#b0c4de",
        "lightyellow": "#ffffe0",
        "lime": "#00ff00",
        "limegreen": "#32cd32",
        "linen": "#faf0e6",
        "magenta": "#ff00ff",
        "maroon": "#800000",
        "mediumaquamarine": "#66cdaa",
        "mediumblue": "#0000cd",
        "mediumorchid": "#ba55d3",
        "mediumpurple": "#9370d8",
        "mediumseagreen": "#3cb371",
        "mediumslateblue": "#7b68ee",
        "mediumspringgreen": "#00fa9a",
        "mediumturquoise": "#48d1cc",
        "mediumvioletred": "#c71585",
        "midnightblue": "#191970",
        "mintcream": "#f5fffa",
        "mistyrose": "#ffe4e1",
        "moccasin": "#ffe4b5",
        "navajowhite": "#ffdead",
        "navy": "#000080",
        "oldlace": "#fdf5e6",
        "olive": "#808000",
        "olivedrab": "#6b8e23",
        "orange": "#ffa500",
        "orangered": "#ff4500",
        "orchid": "#da70d6",
        "palegoldenrod": "#eee8aa",
        "palegreen": "#98fb98",
        "paleturquoise": "#afeeee",
        "palevioletred": "#d87093",
        "papayawhip": "#ffefd5",
        "peachpuff": "#ffdab9",
        "peru": "#cd853f",
        "pink": "#ffc0cb",
        "plum": "#dda0dd",
        "powderblue": "#b0e0e6",
        "purple": "#800080",
        "red": "#ff0000",
        "rosybrown": "#bc8f8f",
        "royalblue": "#4169e1",
        "saddlebrown": "#8b4513",
        "salmon": "#fa8072",
        "sandybrown": "#f4a460",
        "seagreen": "#2e8b57",
        "seashell": "#fff5ee",
        "sienna": "#a0522d",
        "silver": "#c0c0c0",
        "skyblue": "#87ceeb",
        "slateblue": "#6a5acd",
        "slategray": "#708090",
        "snow": "#fffafa",
        "springgreen": "#00ff7f",
        "steelblue": "#4682b4",
        "tan": "#d2b48c",
        "teal": "#008080",
        "thistle": "#d8bfd8",
        "tomato": "#ff6347",
        "turquoise": "#40e0d0",
        "violet": "#ee82ee",
        "wheat": "#f5deb3",
        "white": "#ffffff",
        "whitesmoke": "#f5f5f5",
        "yellow": "#ffff00",
        "yellowgreen": "#9acd32"
      }
}
BurnDownStatusesDiagram.$inject = ['burnDownStatusesDiagramUrl', '$http'];


// WEBPACK FOOTER //
// ./components/burn-down-statuses-diagram/burn-down-statuses-diagram.component.js